const locale = Object.freeze({
  EN_GB: "en-GB",
  EN_US: "en-US",
});

export default locale;
